import type { UserFullName } from 'applications/GSP/shared/utils/user/types';

export const getShortName = <User extends UserFullName>({
  firstName,
  lastName,
}: User) => {
  const [shortFirstName] = Array.from(firstName);
  const [shortLastName] = Array.from(lastName);

  return `${shortFirstName.toUpperCase()}${shortLastName.toUpperCase()}`;
};
